import { apiServer } from "@/setup-axios";

export function getUnreadNotificationCount() {
    return apiServer.get("/notifications/unread/count");
}

export function getLatestNotifications() {
    return apiServer.get("/notifications/latest", {
        params: { limit: 5 }
    });
}

export function markAsReadNotification(notificationId) {
    return apiServer.post(`/notifications/${notificationId}/read`);
}

export function getNotifications(isRead) {
    const params = {};

    if (isRead !== undefined && isRead !== null) {
        params.is_read = isRead;
    }

    return apiServer.get("/notifications/all", { params });
}

export function markAllReadNotifications() {
    return apiServer.post("/notifications/read-all");
}